<script>
import UploadedNotesView from "./UploadedNotes.vue";

export default {
  name: "ProcedureDetails",

  data() {
    return {
      active: 0,
      activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 
                rounded-t-md z-10 -mb-1`,
      inActiveClass: `bg-gray-300 border-l border-r border-t`,
      viewFileNotes: false,
      images: [],
    };
  },

  props: {
    procedure: Object,
    procedureDetails: Object,
    showModal: Boolean,
  },

  methods: {
    fetchFiles() {
      this.$root.loading = true;
      let url = `?PatientID=${this.procedure.patientID}`;
      url += `&ProcedureID=${this.procedure.procedureID}`;

      return this.$http
        .get(`Theatre/GetSurgeryImageList${url}`)
        .then(({ data }) => {
          this.images = data;
          this.$root.loading = false;
          this.viewFileNotes = true;
        })
        .catch(() => {
          this.$root.loading = false;
        });
    },

    printOperationNotes() {
      const url = `/${this.procedure.patientID}?procedureId=${this.procedure.procedureID}`;

      window.open(
        `/theatre/operation-notes/print${url}`,
        "_blank",
        `OperationNotesPrint`,
        "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes"
      );
    },

    printAnaesthesiaNotes() {
      let url = `/theatre/anaesthesia-notes/print/${this.procedure.patientID}`;
      url += `?procedureId=${this.procedure.procedureID}`;

      window.open(
        url,
        "_blank",
        `AnaesthesiaNotesPrint`,
        "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes"
      );
    },

    printPreoperationNotes() {
      const url = `/${this.procedure.patientID}?procedureId=${this.procedure.procedureID}`;

      window.open(
        `/theatre/preoperation-notes/print${url}`,
        "_blank",
        `PreoperationNotesPrint`,
        "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes"
      );
    },

    printPostOperationNotes() {
      const url = `/${this.procedure.patientID}?procedureId=${this.procedure.procedureID}`;

      window.open(
        `/theatre/postoperation-notes/print${url}`,
        "_blank",
        `PostoperationNotesPrint`,
        "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes"
      );
    },

    printProcedureDetails() {
      let url = `/?PatientID=${this.procedure.patientID}`;
      url += `&ProcedureID=${this.procedure.procedureID}`;

      window.open(
        `/theatre/previous-procedures-details-print${url}`,
        "_blank",
        `ProcedureDetailsPrint`,
        "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes"
      );
    },
  },

  components: {
    "view-procedure-notes": UploadedNotesView,
  },
};
</script>
<template>
  <tail-modal :show="showModal" dimension="md:w-2/3 w-11/12">
    <template v-slot:title>
      <h5 class="font-medium text-sm">Procedure Details</h5>
    </template>
    <template v-slot:modal-body>
      <div class="w-full flex flex-wrap -m-3">
        <div class="w-full flex flex-wrap my-2 bg-gray-400 p-tiny">
          <div class="flex-1">
            <h5 class="font-medium text-base">
              {{ procedure.patient || `-` }}
            </h5>
          </div>
          <div class="flex-1">
            <h5 class="font-medium text-base">
              Procedure:
              <span class="text-blue-700 text-xs">{{
                procedure.test || procedure.procedure
              }}</span>
            </h5>
          </div>
        </div>
        <ul class="w-full flex border-b-2 border-gray-500">
          <li class="-mb-px mr-1">
            <a
              href="javascript:void(0)"
              @click.prevent="
                () => {
                  active = 0;
                }
              "
              class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 
                        font-bold whitespace-no-wrap"
              :class="active === 0 ? activeClass : inActiveClass"
              >Personnel</a
            >
          </li>
          <li class="-mb-px mr-1">
            <a
              href="javascript:void(0)"
              @click.prevent="
                () => {
                  active = 1;
                }
              "
              class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 
                        font-bold whitespace-no-wrap"
              :class="active === 1 ? activeClass : inActiveClass"
              >Preoperation Notes</a
            >
          </li>
          <li class="-mb-px mr-1">
            <a
              href="javascript:void(0)"
              @click.prevent="
                () => {
                  active = 2;
                }
              "
              class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 
                        font-bold whitespace-no-wrap"
              :class="active === 2 ? activeClass : inActiveClass"
              >Anaesthetist Notes</a
            >
          </li>
          <li class="-mb-px mr-1">
            <a
              href="javascript:void(0)"
              @click.prevent="
                () => {
                  active = 3;
                }
              "
              class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 
                        font-bold whitespace-no-wrap"
              :class="active === 3 ? activeClass : inActiveClass"
              >Operation Notes</a
            >
          </li>
          <li class="-mb-px mr-1">
            <a
              href="javascript:void(0)"
              @click.prevent="
                () => {
                  active = 4;
                }
              "
              class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 
                        font-bold whitespace-no-wrap"
              :class="active === 4 ? activeClass : inActiveClass"
              >Post Operation Notes</a
            >
          </li>
        </ul>
        <div class="w-full flex flex-wrap p-tiny" v-if="active === 0">
          <div class="md:w-1/3 w-1/2 p-1">
            <h5 class="font-medium text-sm">
              Operation Room:
              <span class="text-blue-600">
                {{ procedureDetails.personnel.operationRoom || `-` }}</span
              >
            </h5>
          </div>
          <div class="md:w-1/3 w-1/2 p-1">
            <h5 class="font-medium text-sm">
              Surgeon:
              <span class="text-blue-600">
                {{ procedureDetails.personnel.surgeon || `-` }}</span
              >
            </h5>
          </div>
          <div class="md:w-1/3 w-1/2 p-1">
            <h5 class="font-medium text-sm">
              Assistant Surgeon:
              <span class="text-blue-600">
                {{ procedureDetails.personnel.assistantSurgeon || `-` }}</span
              >
            </h5>
          </div>
          <div class="md:w-1/3 w-1/2 p-1">
            <h5 class="font-medium text-sm">
              Scrub Nurse:
              <span class="text-blue-600">
                {{ procedureDetails.personnel.scrubNurse || `-` }}</span
              >
            </h5>
          </div>
          <div class="md:w-1/3 w-1/2 p-1">
            <h5 class="font-medium text-sm">
              Anaesthetist:
              <span class="text-blue-600">
                {{ procedureDetails.personnel.anaesthetist || `-` }}</span
              >
            </h5>
          </div>
          <div class="md:w-1/3 w-1/2 p-1">
            <h5 class="font-medium text-sm">
              Type Of Anaesthesia:
              <span class="text-blue-600">
                {{ procedureDetails.personnel.typeofAnaesthesia || `-` }}</span
              >
            </h5>
          </div>
          <div class="md:w-1/3 w-1/2 p-1">
            <h5 class="font-medium text-sm">
              Diagnosis:
              <span class="text-blue-600">
                {{ procedureDetails.personnel.diagnosis || `-` }}</span
              >
            </h5>
          </div>
        </div>
        <div class="w-full flex flex-wrap p-tiny" v-if="active === 1">
          <div
            class="w-full flex flex-wrap"
            v-if="procedureDetails.preoperationNotes.trxDate"
          >
            <div class="flex-1 p-1">
              <h5 class="font-medium text-sm">
                Date:
                {{ procedureDetails.preoperationNotes.trxDate | dateFormat }}
              </h5>
            </div>
            <div
              class="flex-1 flex flex-row p-1"
              v-if="$root.checkAuth(`UpdateProcedureDateForNotes`)"
            >
              <input
                type="date"
                v-model.trim="procedureDetails.preoperationNotes.trxDate"
                class="flex-1 input-control input-sm text-xs"
              />
              <button class="btn-sm btn-primary text-xs rounded-r">
                Update Date
              </button>
            </div>
          </div>
          <div
            class="w-full overflow-auto my-3 bg-gray-100"
            style="max-height:60vh;"
          >
            <span
              v-html="procedureDetails.preoperationNotes.preOperativeNotes"
            ></span>
          </div>
          <div class="p-tiny w-full text-right">
            <button
              @click.prevent="printPreoperationNotes"
              class="btn-sm btn-primary text-xs rounded"
            >
              <i class="fa fa-print"></i> Print
            </button>
          </div>
        </div>
        <div class="w-full flex flex-wrap p-tiny" v-if="active === 2">
          <div
            class="w-full flex flex-wrap"
            v-if="procedureDetails.anaesthesiaNotes.trxDate"
          >
            <div class="flex-1 p-1">
              <h5 class="font-medium text-sm">
                Date:
                {{ procedureDetails.anaesthesiaNotes.trxDate | dateFormat }}
              </h5>
            </div>
            <div
              class="flex-1 flex flex-row p-1"
              v-if="$root.checkAuth(`UpdateProcedureDateForNotes`)"
            >
              <input
                type="date"
                v-model.trim="procedureDetails.anaesthesiaNotes.trxDate"
                class="flex-1 input-control input-sm text-xs"
              />
              <button class="btn-sm btn-primary text-xs rounded-r">
                Update Date
              </button>
            </div>
          </div>
          <div
            class="w-full overflow-auto my-3 bg-gray-100"
            style="max-height:60vh;"
          >
            <span
              v-html="procedureDetails.anaesthesiaNotes.anaesthesiaNotes"
            ></span>
          </div>
          <div class="p-tiny w-full text-right">
            <button
              @click.prevent="printAnaesthesiaNotes"
              class="btn-sm btn-primary text-xs rounded"
            >
              <i class="fa fa-print"></i> Print
            </button>
          </div>
        </div>
        <div class="w-full flex flex-wrap p-tiny" v-if="active === 3">
          <div
            class="w-full flex flex-wrap"
            v-if="procedureDetails.operationNotes.trxDate"
          >
            <div class="flex-1 p-1">
              <h5 class="font-medium text-sm">
                Date: {{ procedureDetails.operationNotes.trxDate | dateFormat }}
              </h5>
            </div>
            <div
              class="flex-1 flex flex-row p-1"
              v-if="$root.checkAuth(`UpdateProcedureDateForNotes`)"
            >
              <input
                type="date"
                v-model.trim="procedureDetails.operationNotes.trxDate"
                class="flex-1 input-control input-sm text-xs"
              />
              <button class="btn-sm btn-primary text-xs rounded-r">
                Update Date
              </button>
            </div>
          </div>
          <div
            class="w-full overflow-auto my-3 bg-gray-100"
            style="max-height:60vh;"
          >
            <span
              v-html="procedureDetails.operationNotes.operationNotes"
            ></span>
          </div>
          <div class="p-tiny w-full text-right">
            <button
              @click.prevent="printOperationNotes"
              class="btn-sm btn-primary text-xs rounded"
            >
              <i class="fa fa-print"></i> Print
            </button>
          </div>
        </div>
        <div class="w-full flex flex-wrap p-tiny" v-if="active === 4">
          <div
            class="w-full flex flex-wrap p-1"
            v-if="procedureDetails.postOperationNotes.trxDate"
          >
            <div class="md:w-1/2 w-1/2">
              <h5 class="font-medium text-sm">
                Date:
                {{ procedureDetails.postOperationNotes.trxDate | dateFormat }}
              </h5>
            </div>
            <div
              class="md:w-1/2 w-1/2 flex flex-row"
              v-if="$root.checkAuth(`UpdateProcedureDateForNotes`)"
            >
              <input
                type="date"
                v-model.trim="procedureDetails.postOperationNotes.trxDate"
                class="flex-1 input-control input-sm text-xs"
              />
              <button class="btn-sm btn-primary text-xs rounded-r">
                Update Date
              </button>
            </div>
          </div>
          <div
            class="w-full overflow-auto my-3 bg-gray-100"
            style="max-height:60vh;"
          >
            <span
              v-html="procedureDetails.postOperationNotes.postOperationNotes"
            ></span>
          </div>
          <div class="p-tiny w-full text-right">
            <button
              @click.prevent="printPostOperationNotes"
              class="btn-sm btn-primary text-xs rounded"
            >
              <i class="fa fa-print"></i> Print
            </button>
          </div>
        </div>
      </div>
      <view-procedure-notes 
        :showModal="viewFileNotes" 
        :fileNotes="images"
        @closeModal="viewFileNotes = false" 
      />
    </template>
    <template v-slot:modal-footer>
      <button
        class="btn-danger btn-sm text-xs rounded mr-6"
        @click.prevent="$emit(`closeModal`)"
      >
        <i class="fa fa-times"></i> Close
      </button>
      <button
        @click.prevent="fetchFiles"
        class="btn-sm btn-info text-xs rounded mr-6"
      >
        <i class="fa fa-eye"></i> View Image Notes
      </button>
      <button
        @click.prevent="printProcedureDetails"
        class="btn-sm btn-primary text-xs rounded"
      >
        <i class="fa fa-print"></i> Print All Notes
      </button>
    </template>
  </tail-modal>
</template>
